import { render, staticRenderFns } from "./cinema-list-header.vue?vue&type=template&id=2a659d8f&"
import script from "./cinema-list-header.vue?vue&type=script&lang=ts&"
export * from "./cinema-list-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports